export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-view-quilt',
        
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['INFORMATION']
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Announcment',
      //   to: '/announcment',
      //   icon: 'cil-bullhorn'
      // },
      {
        _name: 'CSidebarNavItem',
        name: 'Events',
        to: '/event',
        icon: 'cil-calendar'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['DATABASE']
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Member',
        to: '/member',
        icon: 'cil-people',
        items:[
          {
            name : 'Members',
            to: '/member/member'
          },
          
          {
            name : 'Member Report',
            to: '/member/member_report'
          },
          
        ]
      },
      {
      _name: 'CSidebarNavDropdown',
      name: 'New comer',
      to: '/newcomer',
      icon: 'cil-people',
      items:[
        {
          name : 'New Comers',
          to: '/newcomer/newcomer'
        },
        {
          name : 'Newcomer Report',
          to: '/newcomer/newcomer_report'
        },
        {
          name : 'Newcomer Want Icare',
          to: '/newcomer/newcomer_want_icare'
        }
      ]
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'iKids',
      //to: '/ikids/listkids',
      icon: 'cil-child',
      items:[
        {
          name : 'List iKids',
          to: '/ikids/listkids'
        }, 
        {
          name : 'List Graduated',
          to: '/ikids/graduate'
        },
        {
          name : 'Kids check old',
          to: '/ikids/kids-check-old'
        },
        {
          name : 'Class Dashboard',
          to: '/ikids/kids-class',
          target: '_blank'
        },
        {
          name : 'Usher Dashboard',
          to: '/dashboard/kidqueue',
          target: '_blank'
        }
      ]
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'iKids Service',
      icon: 'cil-settings',
      items: [
        {
          name : 'iKids Check In/Out',
          to: '/ikids/kids-check'
        },
        {
          name : 'iKids Check Report',
          to: '/ikids/check-report'
        },
        // {
        //   name : 'Queue Dashboard',
        //   to: '/ikids/kids-queue'
        // },
      ]
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'iCares',
      to: '/icare',
      icon: 'cil-heart',
      items:[
        {
          name : 'Coach Group',
          to: '/icare/coachgroup'
        },
        {
          name : 'List iCares',
          to: '/icare/icare'
        },
        
        {
          name : 'Report iCare',
          to: '/icare/report'
        },
        {
          name : 'Visitor List',
          to: '/icare/visitor'
        },     
        {
          name : 'Icare Join List',
          to: '/icare/icare_join'
        },
        {
          name : 'iCare People Detail',
          to: '/icare/icare_people_detail'
        },
        {
          name : 'People Without iCare',
          to: '/icare/icare_people_without_icare'
        },       
      ]
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'iCares Youth',
      to: '/icare',
      icon: 'cil-heart',
      items:[
        {
          name : 'Coach Group Youth',
          to: '/icare-youth/coachgroupyouth'
        },
        {
          name : 'List iCares Youth',
          to: '/icare-youth/icareyouth'
        },
       
        {
          name : 'Report iCare Youth',
          to: '/icare-youth/reportyouth'
        }
      ]
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'Department',
      to: '/department',
      icon: 'cil-building',
      items:[
        {
          name : 'List Department',
          to: '/department/department',
        },
        {
          name : 'Join List',
          to: '/department/department_join'
        }, 
        {
          name : 'Message',
          to: '/department/department_message'
        },
      ]
    },
   
      {
        _name: 'CSidebarNavItem',
        name: 'Service Attendance',
        to: '/service/service',
        icon: 'cil-star'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Classes',
        to: '/onlineclass',
        icon: 'cil-heart',
        items:[
          {
              name: "Curriculum",
              to: "/onlineclass/curriculumlist",
          },
          {
              name: "Class Template",
              to: "/onlineclass/classlist",
          },
          {
            name: "Schedule",
            to: "/onlineclass/schedule",
          },
          {
            name : 'Class Teacher',
            to: '/onlineclass/class_teacher'
          },
          {
            name : 'Assign Teacher',
            to: '/onlineclass/assignteacher'
          },
          {
            name : 'Result DISC',
            to: '/onlineclass/resultdisc'
          },
          {
            name : 'Result Karunia Rohani',
            to: '/onlineclass/resultkaruniarohani'
          },
          {
            name : 'Result Kesehatan Rohani',
            to: '/onlineclass/resultkesehatanrohani'
          },
          {
            name : 'Result Quiz Komunikasi',
            to: '/onlineclass/resultquizkomunikasi'
          },
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Prayer',
        to: '/prayer/listprayer',
        icon: 'cil-people',
      },    
     
      //master tab
      {
        _name: 'CSidebarNavDropdown',
        name: 'Master',
        route: '/master',
        icon: 'cil-storage',
        items: [
          {
            name: 'Category Sermon',
            to: '/master/categorysermon'
          },
          {
            name: 'Discover',
            to: '/master/discover'
          },
          {
            name: 'General Class',
            to: '/master/general'
          },
          {
            name: 'iKids - Class',
            to: '/master/class'
          },
          {
            name: 'iKids - Clasification',
            to: '/master/clasification'
          },
          {
            name: 'Article Content',
            to: '/master/article'
          },
          {
            name: 'Article Category',
            to: '/master/article-category'
          },
          {
            name: 'Link Content',
            to: '/master/link'
          },
          {
            name: 'Member - Category',
            to: '/master/category'
          },
          {
            name: 'Newcomer - Keperluan',
            to: '/master/keperluan'
          },
          {
            name: 'Newcomer - Tujuan',
            to: '/master/tujuan'
          }, 
          {
            name: 'Satelite Church',
            to: '/master/satelite'
          },
          {
            name: 'Section',
            to: '/master/section'
          }, 
          {
            name: 'Services',
            to: '/master/services'
          },
         
          {
            name: 'Zone',
            to: '/master/zone'
          },
          
        ]
      },  
     
      {
        _name: 'CSidebarNavDropdown',
        name: 'Tools',
        route: '/tools',
        icon: 'cil-puzzle',
        items: [
          {
            name: 'Department Core Teams',
            to: '/tools/department_core_teams'
          },
          {
            name: 'iCare Core Teams',
            to: '/tools/icare_core_teams'
          },
          {
            name: 'iCare Member',
            to: '/tools/icare_member'
          },
         
          {
            name: 'ICL List',
            to: '/tools/icl_list'
          },
          {
            name: 'HOD List',
            to: '/tools/hod_list'
          },
         
          {
            name: 'Kids Report',
            to: '/tools/kids_report'
          },
          
         ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'PEOPLE (BETA)',
        to: '/peoples/peoples',
        icon: 'cil-people'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Deprecated',
        icon: 'cil-bell',
        items: [
          {
            name : '[Deprecated] Kids Check In/Out',
            to: '/ikids/kids-check-old-1'
          },
          {
            name : '[Deprecated] Class Dashboard',
            to: '/ikids/kids-class-old'
          },
          {
            name : '[Deprecated] Usher Dashboard',
            to: '/dashboard/kidqueue-old'
          },
        ]
      },


      
    ]
  }
]
